import { render, staticRenderFns } from "./ModalBooks.vue?vue&type=template&id=294af8ee&scoped=true&"
import script from "./ModalBooks.vue?vue&type=script&lang=js&"
export * from "./ModalBooks.vue?vue&type=script&lang=js&"
import style0 from "./ModalBooks.vue?vue&type=style&index=0&id=294af8ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294af8ee",
  null
  
)

export default component.exports